import { MainInner } from "@/styles/global";
import { Body, SmallHeading1Css, SmallHeading2 } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";
import { css } from "styled-components";

const Section = styled.div`
  margin: 24px 0 48px;
`;

const Container = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const CardCss = css<{ $external: boolean }>`
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: #00000059;
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  width: 100%;
  min-height: 264px;
  height: 100%;

  svg {
    transition: transform 0.3s;
    transform: ${({ $external }) => ($external ? "rotate(-45deg)" : "none")};
  }

  &:hover {
    svg {
      transform: ${({ $external }) =>
        $external ? "rotate(-45deg) translateX(10px)" : "translateX(10px)"};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
    min-height: 204px;
  }
`;

const Card = styled(Link)<{ $external: boolean }>`
  ${CardCss}
`;

const CardExternal = styled.a<{ $external: boolean }>`
  ${CardCss}
`;

const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  height: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: grid;
    gap: 32px;
    align-items: center;
    grid-template-columns: auto max-content;
  }
`;

const CardDate = styled(Body)`
  margin-bottom: 8px;
  font-size: 16px;
`;

const CardReadMoreWrapper = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: space-between;
  align-items: end;
  height: 100%;
`;

const CardReadMore = styled(SmallHeading2)`
  width: max-content;
`;

const ScrollContainer = styled(MainInner)`
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 10;
  margin-top: 24px;
`;

const Filters = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    overflow: unset;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const Filter = styled.a<{ $active?: boolean }>`
  ${SmallHeading1Css}
  padding: 8px 0;
  min-width: max-content;
  display: flex;
  text-decoration: none;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  opacity: ${({ $active }) =>
    $active === undefined ? 1 : $active === true ? 1 : 0.5};
  border-bottom: ${({ $active, theme }) =>
    `2px solid ${theme.colors[$active ? "pink" : "transparent"]}`};

  &:first-of-type {
    margin-left: 16px;
  }

  &:last-of-type {
    margin-right: 16px;
    padding-right: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: max-content;
    transition: all 0.2s ease-in-out;

    opacity: ${({ $active }) =>
      $active == undefined ? 1 : $active == true ? 1 : 0.6};

    &:hover {
      opacity: ${({ $active }) => ($active == undefined ? 0.6 : 1)};
    }

    padding: 0;
    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const S = {
  Section,
  Container,
  Card,
  CardExternal,
  CardTextWrapper,
  ContentWrapper,
  CardDate,
  CardReadMoreWrapper,
  CardReadMore,

  ScrollContainer,
  Filters,
  Filter,
};

export default S;
